export const RB = ({ icon: Icon, label, onClick, active, testid, tall, disabled, text }) => (
  <button type="button" data-testid={testid} title={label} aria-label={label} disabled={disabled}
    onMouseDown={(e) => e.preventDefault()} onClick={onClick}
    className={`rb ${active ? "rb-active" : ""} ${tall ? "rb-tall" : ""} ${text ? "px-2 gap-1.5 text-xs" : ""}`}>
    {Icon && <Icon className={tall ? "h-5 w-5" : "h-4 w-4"} strokeWidth={1.75} />}
    {(tall || text) && <span>{text || label}</span>}
  </button>
);

export const Group = ({ label, children }) => (
  <div className="rg">
    <div className="rg-items">{children}</div>
    <div className="rg-label">{label}</div>
  </div>
);

export const ColorBtn = ({ icon: Icon, label, value, onChange, testid }) => (
  <label className="rb relative cursor-pointer" title={label} onMouseDown={(e) => e.stopPropagation()}>
    <Icon className="h-4 w-4" strokeWidth={1.75} />
    <span className="absolute bottom-1 left-2 right-2 h-[3px] rounded-sm" style={{ background: value }} />
    <input type="color" data-testid={testid} aria-label={label} value={value}
      onChange={(e) => onChange(e.target.value)} className="absolute inset-0 opacity-0 cursor-pointer w-full h-full" />
  </label>
);

export const NSelect = ({ value, onChange, options, testid, width, label }) => (
  <select className="rsel" style={{ width }} data-testid={testid} aria-label={label} title={label}
    value={value} onChange={(e) => onChange(e.target.value)}>
    {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
  </select>
);
